import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataStorageService } from '../../../shared/services/data-storage.service';
// services
import { CopyService } from '../../../shared/services/app-copy.service';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// models
import { AppState } from '../../../booking/models/app-state.interface';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-error-500',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './error-500.component.html',
  styleUrls: ['./error-500.component.scss'],
  providers: [DataStorageService]
})
export class Error500Component implements OnInit, OnDestroy {

  private _bookingInitSubscription: Subscription;
  private _userLanguageSubscription: Subscription;

  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';

  constructor(
    private _appStore: Store<AppState>,
    private _copyService: CopyService,
    private _dataStorage: DataStorageService
  ) { }

  ngOnInit() {
    this._dataStorage.removeCookie('dataID');
    this._copyService.getStaticCopy();

    this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
            this.copyLoaded = res.copyLoaded;
            if (res.copyLoaded) {

              this.getCopy();
            }

            this._userLanguageSubscription = this._appStore.select('copyReducer')
              .subscribe((res: any) => {
                this.selectedLanguage = res.language
              })

        });
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      window.location.pathname.split('/')[1],
      ['panelHeader']
    );
    // console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };
  }

  ngOnDestroy() {
    if (this._bookingInitSubscription) {this._bookingInitSubscription.unsubscribe();}
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }
  }


}
